import { SET_CHART_INTERVAL, SET_CHART_THEME } from './types';

// Persist to localStorage and dispatch
export const setChartInterval = (interval) => dispatch => {
  localStorage.setItem('chart-interval', JSON.stringify(interval));
  dispatch({
    type: SET_CHART_INTERVAL,
    payload: interval,
  });
};

export const setChartTheme = (isDark) => dispatch => {
  localStorage.setItem('chart-theme', JSON.stringify(isDark));
  dispatch({
    type: SET_CHART_THEME,
    payload: isDark,
  });
};
